const PROCEDIMENTOS_SEM_ESPELHO = [1, 3, 58];

const avisoJaFaturado = message =>
  /já foi faturado/i.test(message || '') ? message : null;

/**
 * O espelho só abre quando o backend devolve os laudos gravados.
 * Resposta 200 sem `faturado` (chave de idempotência órfã) não tem o que imprimir.
 */
export default function resultadoInsertFaturamento({
  data,
  codProcedi,
  codPac,
}) {
  const itens = (Array.isArray(data?.faturado) ? data.faturado : []).filter(
    item => Number(item.CODPAC) === Number(codPac)
  );
  const showAlertEspelho =
    !PROCEDIMENTOS_SEM_ESPELHO.includes(Number(codProcedi)) && itens.length > 0;

  return {
    message: data?.message,
    showAlertEspelho,
    faturado: showAlertEspelho ? itens : undefined,
    aviso: showAlertEspelho ? null : avisoJaFaturado(data?.message),
  };
}
